<template>
  <RestaurantRequestsForm :typeEndPoint="'restaurantRequestsForm'" :dataParams="{}"/>
</template>
<script>
import RestaurantRequestsForm from '@/components/modules/restaurant/requests/form'
export default {
  name: 'RestaurantRequestsCreate',
  components: {
    RestaurantRequestsForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/restaurant/requests/create.vue